import { rawClient, thinkificClient } from "../../../../ajax";
import {
  sendingRequest,
  receivedResponse,
  createAction
} from "../../../../redux_util";
import formatError from "../../../../formatErrors";

export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS";

export const signUpSuccess = createAction(USER_SIGNUP_SUCCESS, "data");
export const signUp = data => {
  return dispatch => {
    dispatch(sendingRequest("signUp"));
    return thinkificClient
      .post(`users`, data)
      .then(res => {
        dispatch(receivedResponse("signUp"));
        return dispatch(signUpSuccess(res.data));
      })
      .catch(err => {
        return dispatch(receivedResponse("signUp", formatError(err)));
      });
  };
};

export const USER_LOCAL_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS";

export const localSignUpSuccess = createAction(
  USER_LOCAL_SIGNUP_SUCCESS,
  "data"
);
export const localSignUp = data => {
  return dispatch => {
    dispatch(sendingRequest("localSignUp"));
    return rawClient
      .post(`signup`, data)
      .then(res => {
        dispatch(receivedResponse("localSignUp"));
        return dispatch(localSignUpSuccess(res.data));
      })
      .catch(err => {
        return dispatch(receivedResponse("localSignUp", formatError(err)));
      });
  };
};

// JWT SIGNUP

export const CREATE_JWT_SUCCESS = "CREATE_JWT_SUCCESS";

export const createJwtSuccess = createAction(CREATE_JWT_SUCCESS, "data");
export const createJwt = data => {
  return dispatch => {
    dispatch(sendingRequest("createJwt"));
    return rawClient
      .post(`jwtsignup`, data)
      .then(res => {
        dispatch(receivedResponse("createJwt"));
        return dispatch(
          createJwtSuccess(res.headers["authorization"] || "", res.data)
        );
      })
      .catch(err => {
        return dispatch(receivedResponse("createJwt", formatError(err)));
      });
  };
};



// WEBPACK FOOTER //
// ./src/components/screens/Signup/redux/actions.js